module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "affix-placeholder",
    style: (_vm.wrapStyle)
  }, [_c('div', {
    class: {
      'affix': _vm.affixed
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f635e1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affix/Affix.vue
// module id = 334
// module chunks = 0